/**
 * Configurations des formats téléphoniques par pays
 * Inclut l'indicatif, le format et le masque pour chaque pays d'Afrique de l'Ouest
 */

export const PHONE_FORMATS = {
  "Bénin": {
    code: "+229",
    format: "+229 XX XX XX XX",
    placeholder: "+229 97 12 34 56",
    digitCount: 8,
    regex: /^\+229\s\d{2}\s\d{2}\s\d{2}\s\d{2}$/
  },
  "Burkina Faso": {
    code: "+226",
    format: "+226 XX XX XX XX",
    placeholder: "+226 70 12 34 56",
    digitCount: 8,
    regex: /^\+226\s\d{2}\s\d{2}\s\d{2}\s\d{2}$/
  },
  "Cap-Vert": {
    code: "+238",
    format: "+238 XXX XX XX",
    placeholder: "+238 991 12 34",
    digitCount: 7,
    regex: /^\+238\s\d{3}\s\d{2}\s\d{2}$/
  },
  "Côte d'Ivoire": {
    code: "+225",
    format: "+225 XX XX XX XX XX",
    placeholder: "+225 07 12 34 56 78",
    digitCount: 10,
    regex: /^\+225\s\d{2}\s\d{2}\s\d{2}\s\d{2}\s\d{2}$/
  },
  "Gambie": {
    code: "+220",
    format: "+220 XXX XXXX",
    placeholder: "+220 701 2345",
    digitCount: 7,
    regex: /^\+220\s\d{3}\s\d{4}$/
  },
  "Ghana": {
    code: "+233",
    format: "+233 XX XXX XXXX",
    placeholder: "+233 24 123 4567",
    digitCount: 9,
    regex: /^\+233\s\d{2}\s\d{3}\s\d{4}$/
  },
  "Guinée": {
    code: "+224",
    format: "+224 XXX XX XX XX",
    placeholder: "+224 620 12 34 56",
    digitCount: 9,
    regex: /^\+224\s\d{3}\s\d{2}\s\d{2}\s\d{2}$/
  },
  "Guinée-Bissau": {
    code: "+245",
    format: "+245 XXX XXXX",
    placeholder: "+245 955 1234",
    digitCount: 7,
    regex: /^\+245\s\d{3}\s\d{4}$/
  },
  "Liberia": {
    code: "+231",
    format: "+231 XX XXX XXXX",
    placeholder: "+231 77 012 3456",
    digitCount: 9,
    regex: /^\+231\s\d{2}\s\d{3}\s\d{4}$/
  },
  "Mali": {
    code: "+223",
    format: "+223 XX XX XX XX",
    placeholder: "+223 70 12 34 56",
    digitCount: 8,
    regex: /^\+223\s\d{2}\s\d{2}\s\d{2}\s\d{2}$/
  },
  "Niger": {
    code: "+227",
    format: "+227 XX XX XX XX",
    placeholder: "+227 90 12 34 56",
    digitCount: 8,
    regex: /^\+227\s\d{2}\s\d{2}\s\d{2}\s\d{2}$/
  },
  "Nigeria": {
    code: "+234",
    format: "+234 XXX XXX XXXX",
    placeholder: "+234 802 123 4567",
    digitCount: 10,
    regex: /^\+234\s\d{3}\s\d{3}\s\d{4}$/
  },
  "Sénégal": {
    code: "+221",
    format: "+221 XX XXX XX XX",
    placeholder: "+221 77 123 45 67",
    digitCount: 9,
    regex: /^\+221\s\d{2}\s\d{3}\s\d{2}\s\d{2}$/
  },
  "Sierra Leone": {
    code: "+232",
    format: "+232 XX XXX XXX",
    placeholder: "+232 76 123 456",
    digitCount: 8,
    regex: /^\+232\s\d{2}\s\d{3}\s\d{3}$/
  },
  "Togo": {
    code: "+228",
    format: "+228 XX XX XX XX",
    placeholder: "+228 90 12 34 56",
    digitCount: 8,
    regex: /^\+228\s\d{2}\s\d{2}\s\d{2}\s\d{2}$/
  },
  "Autre": {
    code: "+",
    format: "+XXX XXXXXXXXXX",
    placeholder: "+XXX XXXXXXXXXX",
    digitCount: 15,
    regex: /^\+\d{1,15}$/
  }
};

/**
 * Obtenir la configuration téléphonique pour un pays donné
 * @param {string} country - Nom du pays
 * @returns {object} Configuration du format téléphonique
 */
export const getPhoneConfig = (country) => {
  return PHONE_FORMATS[country] || PHONE_FORMATS["Côte d'Ivoire"];
};

/**
 * Formater un numéro de téléphone selon le pays
 * @param {string} value - Numéro brut
 * @param {string} country - Pays sélectionné
 * @returns {string} Numéro formaté
 */
export const formatPhoneNumber = (value, country) => {
  const config = getPhoneConfig(country);
  
  // Extraire uniquement les chiffres
  const digits = value.replace(/\D/g, '');
  
  // Extraire le code pays des chiffres (si présent)
  const codeDigits = config.code.replace(/\D/g, '');
  
  // Si les premiers chiffres correspondent au code pays, les ignorer
  let phoneDigits = digits;
  if (digits.startsWith(codeDigits)) {
    phoneDigits = digits.substring(codeDigits.length);
  }
  
  // Limiter au nombre de chiffres autorisés
  phoneDigits = phoneDigits.substring(0, config.digitCount);
  
  // Formater selon le pays
  let formatted = config.code;
  
  switch (country) {
    case "Côte d'Ivoire":
      // +225 XX XX XX XX XX (10 chiffres)
      if (phoneDigits.length > 0) formatted += ' ' + phoneDigits.substring(0, 2);
      if (phoneDigits.length > 2) formatted += ' ' + phoneDigits.substring(2, 4);
      if (phoneDigits.length > 4) formatted += ' ' + phoneDigits.substring(4, 6);
      if (phoneDigits.length > 6) formatted += ' ' + phoneDigits.substring(6, 8);
      if (phoneDigits.length > 8) formatted += ' ' + phoneDigits.substring(8, 10);
      break;
      
    case "Sénégal":
      // +221 XX XXX XX XX (9 chiffres)
      if (phoneDigits.length > 0) formatted += ' ' + phoneDigits.substring(0, 2);
      if (phoneDigits.length > 2) formatted += ' ' + phoneDigits.substring(2, 5);
      if (phoneDigits.length > 5) formatted += ' ' + phoneDigits.substring(5, 7);
      if (phoneDigits.length > 7) formatted += ' ' + phoneDigits.substring(7, 9);
      break;
      
    case "Nigeria":
      // +234 XXX XXX XXXX (10 chiffres)
      if (phoneDigits.length > 0) formatted += ' ' + phoneDigits.substring(0, 3);
      if (phoneDigits.length > 3) formatted += ' ' + phoneDigits.substring(3, 6);
      if (phoneDigits.length > 6) formatted += ' ' + phoneDigits.substring(6, 10);
      break;
      
    case "Ghana":
    case "Guinée":
    case "Liberia":
      // +XXX XX XXX XXXX (9 chiffres)
      if (phoneDigits.length > 0) formatted += ' ' + phoneDigits.substring(0, 2);
      if (phoneDigits.length > 2) formatted += ' ' + phoneDigits.substring(2, 5);
      if (phoneDigits.length > 5) formatted += ' ' + phoneDigits.substring(5, 9);
      break;
      
    case "Cap-Vert":
      // +238 XXX XX XX (7 chiffres)
      if (phoneDigits.length > 0) formatted += ' ' + phoneDigits.substring(0, 3);
      if (phoneDigits.length > 3) formatted += ' ' + phoneDigits.substring(3, 5);
      if (phoneDigits.length > 5) formatted += ' ' + phoneDigits.substring(5, 7);
      break;
      
    case "Gambie":
    case "Guinée-Bissau":
      // +XXX XXX XXXX (7 chiffres)
      if (phoneDigits.length > 0) formatted += ' ' + phoneDigits.substring(0, 3);
      if (phoneDigits.length > 3) formatted += ' ' + phoneDigits.substring(3, 7);
      break;
      
    case "Sierra Leone":
      // +232 XX XXX XXX (8 chiffres)
      if (phoneDigits.length > 0) formatted += ' ' + phoneDigits.substring(0, 2);
      if (phoneDigits.length > 2) formatted += ' ' + phoneDigits.substring(2, 5);
      if (phoneDigits.length > 5) formatted += ' ' + phoneDigits.substring(5, 8);
      break;
      
    default:
      // Bénin, Burkina Faso, Mali, Niger, Togo: +XXX XX XX XX XX (8 chiffres)
      if (phoneDigits.length > 0) formatted += ' ' + phoneDigits.substring(0, 2);
      if (phoneDigits.length > 2) formatted += ' ' + phoneDigits.substring(2, 4);
      if (phoneDigits.length > 4) formatted += ' ' + phoneDigits.substring(4, 6);
      if (phoneDigits.length > 6) formatted += ' ' + phoneDigits.substring(6, 8);
      break;
  }
  
  return formatted;
};

/**
 * Valider un numéro de téléphone selon le pays
 * @param {string} phone - Numéro à valider
 * @param {string} country - Pays sélectionné
 * @returns {boolean} true si valide
 */
export const validatePhoneNumber = (phone, country) => {
  const config = getPhoneConfig(country);
  return config.regex.test(phone);
};
